// Centralized API client
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function joinWaitlist(payload) {
  const { data } = await api.post("/waitlist", payload);
  return data;
}

export async function requestWalkthrough(payload) {
  const { data } = await api.post("/walkthrough", payload);
  return data;
}

export async function submitCommunityQuestion(payload) {
  const { data } = await api.post("/community-question", payload);
  return data;
}
